<template>
  <div class="home">
    <div v-if="isMaxScreen" class="main-content">
      <div class="trade-in-process">
        <div v-if="status < 4" class="trade-in-process-title">{{$t('component.tradeInProcess.TradeIn')}}</div>
        <div v-else-if="status == 4" class="trade-in-process-title">{{$t('component.tradeInProcess.649f8aefats0')}}</div>
        <div v-else-if="status == 5" class="trade-in-process-title">{{$t('component.tradeInProcess.649f8aefc1c0')}}</div>
        <div v-if="status < 4"  class="steps">
          <!-- step1 -->
          <div class="step">
            <img src="../../../assets/image/order/1.png" alt="" class="step-icon" />
            <span class="step-title">{{$t('component.tradeInProcess.start')}}</span>
            <span class="step-content">{{$t('component.tradeInProcess.success')}}</span>
            <img src="../../../assets/image/order/14.png" alt="" class="step-line" />
          </div>
          <!-- step2 -->
          <div class="step">
            <img
              :src="
                status > 1
                  ? require('../../../assets/image/order/2.png')
                  : require('../../../assets/image/order/3.png')
              "
              alt=""
              class="step-icon"
            />
            <span class="step-title">{{$t('component.tradeInProcess.qc')}}</span>
            <span class="step-content"
              >{{$t('component.tradeInProcess.business')}}</span
            >
            <img src="../../../assets/image/order/15.png" alt="" class="step-line2" />
          </div>
          <!-- step3 -->
          <div v-if="status != 4" class="step">
            <img
              :src="
                status == 3
                  ? require('../../../assets/image/order/5.png')
                  : require('../../../assets/image/order/4.png')
              "
              alt=""
              class="step-icon"
            />
            <span class="step-title">{{$t('component.tradeInProcess.completed')}}</span>
            <span class="step-content">{{$t('component.tradeInProcess.successfully')}}</span>
          </div>

        </div>
        <div v-else class="reclaim-failure-box">
          <!-- 超时取消 4-已取消 (1:121 天物流未揽收，自动取消 2:消费者退新机单)-->
          <template v-if="status == 4">
            <img src="../../../assets/image/order/cancel-after-timeout.png" alt="" class="empty" />
            <div class="reclaim-failure-text">{{$t('component.tradeInProcess.656g0lj3qc1a')}}</div>
          </template>
          <!-- 回收失败：拒绝回收 => 5-已退单 (仓库质检后存在价差，用户不同意二次报价退单) -->
          <template  v-if="status == 5">
            <img src="../../../assets/image/order/reclaim-failure.png" alt="" class="empty" />
            <div class="reclaim-failure-text">{{$t('component.tradeInProcess.failRey')}}</div>
          </template>
          <!-- 快速估价按钮，跳转至官网自有以旧换新页 -->
          <div>
            <el-button class="high-priced-reclaim-btn" @click="handleGoto">{{$t('component.tradeInProcess.649f8aefc9c0')}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="main-content">
      <!-- trade-in-process -->
      <div class="trade-in-process">
        <h5 v-if="status < 4">
          {{$t('component.tradeInProcess.TradeIn')}}
          <img src="../../../assets/image/order/wenhao_icon.png" alt="" class="order-wenhao-icon" @click="handleClickWenhao"/>
        </h5>
        <h5 v-else-if="status == 4">{{$t('component.tradeInProcess.649f8aefats0')}}</h5>
        <h5 v-else-if="status == 5">{{$t('component.tradeInProcess.649f8aefc1c0')}}</h5>

        <div v-if="status < 4" class="steps">
          <!-- step1 -->
          <div class="step">
            <div class="step-icon-box">
              <img src="../../../assets/image/order/1.png" alt="" class="step-icon" />
            </div>
            <div class="step-title-content">
              <span class="step-title finish">{{$t('component.tradeInProcess.start')}}</span>
            </div>
            <img src="../../../assets/image/order/step_icon.png" alt="" class="order-step-icon"/>
          </div>
          <!-- step2 -->
          <div class="step">
            <div class="step-icon-box">
              <img
                :src="
                  status > 1
                    ? require('../../../assets/image/order/2.png')
                    : require('../../../assets/image/order/3.png')
                "
                alt=""
                class="step-icon"
              />
            </div>
            <div class="step-title-content">
              <span :class="['step-title', {'finish': status > 1}]">{{$t('component.tradeInProcess.qc')}}</span>
            </div>
            <img src="../../../assets/image/order/step_icon.png" alt="" class="order-step-icon"/>
          </div>
          <!-- step3 -->
          <div v-if="status != 4" class="step">
            <div class="step-icon-box">
              <img
                :src="
                  status == 3
                    ? require('../../../assets/image/order/5.png')
                    : require('../../../assets/image/order/4.png')
                "
                alt=""
                class="step-icon"
              />
            </div>
            <div class="step-title-content">
              <span :class="['step-title', {'finish': status == 3}]">{{$t('component.tradeInProcess.completed')}}</span>
            </div>
          </div>
        </div>

        <div v-else class="reclaim-failure-box">
          <!-- 超时取消 4-已取消 (1:121 天物流未揽收，自动取消 2:消费者退新机单)-->
          <template v-if="status == 4">
            <img src="../../../assets/image/order/cancel-after-timeout.png" alt="" class="empty" />
            <div class="reclaim-failure-text">
              {{$t('component.tradeInProcess.656g0lj3qc1a')}}
            </div>
          </template>
          <!-- 回收失败：拒绝回收 => 5-已退单 (仓库质检后存在价差，用户不同意二次报价退单) -->
          <template  v-if="status == 5">
            <img src="../../../assets/image/order/reclaim-failure.png" alt="" class="empty" />
            <div class="reclaim-failure-text">{{$t('component.tradeInProcess.656g0lj3qfgb')}}</div>
          </template>
          <!-- 快速估价按钮，跳转至官网自有以旧换新页 -->
          <div>
            <van-button class="high-priced-reclaim-btn" @click="handleGoto">{{$t('component.tradeInProcess.649f8aefc9c0')}}</van-button>
          </div>
        </div>
      </div>

      <!-- 回收流程释义弹窗 -->
      <van-dialog v-model="dialogVisible" :title="$t('component.tradeInProcess.656g0lj3sav6')" :show-confirm-button="false" close-on-click-overlay>
        <div class="dialog-content">
          <div class="row">
            1.<div class="text">{{$t('component.tradeInProcess.656g0lj3cd5a')}}</div>
          </div>
          <div class="row">
            2.<div>{{$t('component.tradeInProcess.656g0lj3dr9a')}}</div>
          </div>
          <div class="row">
            3.<div>{{$t('component.tradeInProcess.656g0lj3epal')}}</div>
          </div>
        </div>
        <div class="btn-box">
          <van-button class="btn" @click="handleClickWenhao">{{$t('component.tradeInProcess.656g0lj3qhie')}}</van-button>
        </div>
      </van-dialog>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'tradeInProcess',
  components: {},
  props: {
    status: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  methods: {
    handleClickWenhao(){
      this.dialogVisible = !this.dialogVisible
    },
    handleGoto(){
      // window.location.href = 'http://www.baidu.com'
      this.$router.push({ name: 'Home' });
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  h5 {
    color: #252629;
    font-family: 'PingFang SC';
    font-size: 32px;
    font-weight: 600;
    padding: 32px;
    margin: 0;
    text-align: left;
  }

  .trade-in-process {
    width: 686px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 0 auto 24px;
    padding-bottom: 32px;

    .order-wenhao-icon{
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      position: relative;
      top: 2px;
    }


    .steps {
      display: flex;
      .step {
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 12px;
        // height: 150px;
        align-items: center;
        width: 33.33%;
        position: relative;

        .order-step-icon{
          width: 60px;
          height: 20px;
          position: absolute;
          right: -30px;
          top: 16px;
        }

        .step-icon-box {
          width: 100px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .step-icon {
          // width: 60px;
          height: 50px;
          display: inline-block;
        }

        .step-title-content {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .step-title {
          margin-top: 30px;
          color: #999;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          &.finish{
            color: #333;
          }
        }

        .step-content {
          color: #666;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top: 8px;
        }
      }
    }

    .reclaim-failure-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 32px 32px;

      .empty {
        width: 346px;
        height: 190px;
      }
      .reclaim-failure-text{
        margin-top: 32px;
        color: #666;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 24px;
        font-weight: 400;
      }

    .high-priced-reclaim-btn {
      border-radius: 8px;
      border: 1px solid #ff9602;
      color: #ff9602 !important;
      font-family: 'PingFang SC';
      font-size: 28px;
      font-weight: 400;
      margin: 24px 32px 0;
      width: 620px;
      span{
        color: #ff9602 !important;
      }
    }
      h5 {
        padding: 0;
        margin-top: -30px;
      }
      span {
        text-align: center;
        margin: 20px 0;
        color: #666;
        font-family: 'PingFang SC';
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .dialog-content{
    padding: 24px 40px 0 48px;
    color: #252629;
    font-family: "PingFang SC";
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    .row{
      display: flex;
      margin-bottom: 20px;
    }
  }
  .btn-box{
    display: flex;
    justify-content: space-between;
    margin: 48px;
      .btn{
        display: flex;
        flex: 1;
        height: 88px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 10px;
        background: var(---Brand-1, #405FFF);
        color: #fff;
        border: none;
        font-size: 28px;
      }
  }
  /deep/.van-dialog__header{
    font-weight: bold;
  }
}

@media (min-width: 981px) {
  .main-content {
    background-color: #fff;
    width: 100%;
  }

  .reclaim-failure-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 32px;

    .empty {
      width: 370px;
      height: 204px;
      margin: 30px 0;
    }
    .reclaim-failure-text{
      width: 812px;
      color: #666;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 400;
    }

  .high-priced-reclaim-btn {
    border-radius: 8px;
    border: 1px solid #ff9602;
    color: #ff9602 !important;
    font-family: 'PingFang SC';
    font-size: 21px;
    font-weight: 400;
    margin: 24px 32px 0;
    width: 422px;
    span{
      color: #ff9602 !important;
    }
  }
    h5 {
      padding: 0;
      margin-top: -30px;
    }
    span {
      text-align: center;
      margin: 20px 0;
      color: #666;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .empty-title {
    color: #333;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .empty-content {
    color: #666;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 70px;
  }

  .trade-in-process {
    overflow: hidden;
    width: 1680px;
    margin: 0 auto;
    background-color: #fff;
    // height: 600px;

    .trade-in-process-title {
      color: #252629;
      font-family: 'PingFang SC';
      font-size: 45px;
      font-weight: 600;
      text-align: center;
      margin-top: 45px;
    }
    .steps {
      display: flex;
      margin-bottom: 45px;
      margin-top: 80px;

      .step {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 10px;
        // justify-content: center;
        align-items: center;

        .step-line {
          position: absolute;
          width: 360px;
          right: -180px;
          top: -60px;
        }

        .step-line2 {
          position: absolute;
          width: 360px;
          right: -180px;
          top: 20px;
        }

        .step-icon {
          // width: 60px;
          height: 70px;
        }

        .step-title {
          color: #333;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          margin-top: 30px;
        }

        .step-content {
          color: #666;
          text-align: center;
          font-family: 'PingFang SC';
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top: 6px;
        }
      }
    }
  }
}
</style>
